import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const BedSolid = t0 => {
  const $ = _c(8);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M1.59385 5.23619C1.59385 4.50552 2.18829 3.91105 2.91898 3.91105H5.8936C6.35549 3.91105 6.76275 4.14877 7 4.5081C7.23729 4.14874 7.64451 3.91105 8.10641 3.91105H11.081C11.8117 3.91105 12.4062 4.50552 12.4062 5.23619V5.29721H12.7379V4.00501C12.7379 3.20314 12.0855 2.55078 11.2837 2.55078H2.71631C1.91445 2.55078 1.26208 3.20314 1.26208 4.00501V5.29721H1.59382L1.59385 5.23619Z" />;
    t2 = <path d="M13.443 5.91602H0.556928C0.249836 5.91602 0 6.16585 0 6.47294V9.70603C0 10.0131 0.249836 10.263 0.556928 10.263H0.788762L0.514835 11.0361C0.457753 11.1971 0.542085 11.374 0.703125 11.431C0.737304 11.4431 0.772179 11.4489 0.806475 11.4489C0.933828 11.4489 1.05315 11.3696 1.09811 11.2427L1.44527 10.2629H12.5547L12.9019 11.2427C12.9468 11.3696 13.0661 11.4489 13.1935 11.4489C13.2278 11.4489 13.2627 11.4431 13.2969 11.431C13.4579 11.3739 13.5422 11.1971 13.4852 11.0361L13.2112 10.263H13.4431C13.7502 10.263 14 10.0131 14 9.70603V6.47294C14 6.16585 13.7502 5.91602 13.443 5.91602Z" />;
    t3 = <path d="M8.10646 4.53027C7.71701 4.53027 7.40015 4.84711 7.40015 5.23656V5.29758H11.7874V5.23656C11.7874 4.84711 11.4706 4.53027 11.0811 4.53027H8.10646Z" />;
    t4 = <path d="M2.91896 4.53027C2.52948 4.53027 2.21265 4.84714 2.21265 5.23659V5.29758H6.59989V5.23656C6.59989 4.84711 6.28306 4.53027 5.89357 4.53027H2.91896Z" />;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== props) {
    t5 = <IconWrapper {...props} variant="solid" viewBox="-1 -1 16 16">{t1}{t2}{t3}{t4}</IconWrapper>;
    $[6] = props;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
export { BedSolid };